import React from 'react';
import CollapsableContainer from '../../../../core-components/CollapsableContainer/CollapsableContainer';
import * as S from './HomeDesc.styles';

interface IDescription {
    content: string
}

export default function HomeDesc({ content = '' }: IDescription) {
    if (!content) return null;
    return (
        <S.DescriptionWrapper>
            <CollapsableContainer>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </CollapsableContainer>
        </S.DescriptionWrapper>
    )
}